<template>
  <div class="bg-cream-deep tc br-14 pa-50 mb-pa-30 mb-mb-60">
    <picture>
      <source type="image/webp"
              :srcset="`${ASSETS_CDN}/images/gallery/avatars.webp`" class="mb-30">
      <img
           :srcset="`${ASSETS_CDN}/images/gallery/avatars.png`" class="mb-30" alt="avatars">
    </picture>
    <h2 class="mb-20 fs-36 lh-1 fw-900 ttc mb-fs-28">Meet Our {{ countryName }} Local Designers</h2>
    <p class="mb-0 fs-18 lh-22 wp-100 maxw-450 ma-0-auto">
      Our network of trusted <span class='ttc'>{{ countryName }}</span> Local Designers are the best at designing extraordinary travel experiences, just for you.
    </p>
    <div class='mt-30'>
      <router-link :to="{ name: 'gallery-local-designers', params: { country: countryURL } }" class="button button-primary">
        <span class='white'>Meet Our Local Designers</span>
      </router-link>
<!--      <a :href="`/${countryURL}/local-designers`" class="button button-black">
        <span class='white'>Meet Our Local Designers</span>
      </a>-->
    </div>
  </div>
</template>
<script>
import {assetCDN} from '~/helper/index.js';
export default {
  props: {
    countryName: {
      type: String,
      default: '',
      required: true,
    },
    countryURL: {
      type: String,
      default: ''
    }
  },
  setup() {
    const ASSETS_CDN = assetCDN()

    return {ASSETS_CDN}
  }
}
</script>
